module.exports = __webpack_public_path__ + "img/screenshot-selection.5d153f7f.png";